/* eslint-disable class-methods-use-this */

import { WebPlugin, registerWebPlugin } from '@capacitor/core';

let fb;
(async () => {
  const site = process.env.VUE_APP_SITE;
  const { default: fbModule } = await import(`@/firebaseConfig${site === 'mktg' ? '-mktg' : ''}`);
  fb = fbModule;
})();

class AnalyticsPluginWeb extends WebPlugin {
  constructor() {
    super({
      name: 'AnalyticsPlugin',
      platforms: ['web'],
    });
  }

  setAnalyticsCollectionEnabled(enabled) {
    fb.analytics.setAnalyticsCollectionEnabled(enabled);
  }

  setUserProperty({ name, value }) {
    fb.analytics.setUserProperties({ [name]: value });
  }

  setUserId({ userId }) {
    fb.analytics.setUserId(userId);
  }

  setCurrentScreen({ screenName }) {
    fb.analytics.setCurrentScreen(screenName);
    fb.analytics.logEvent('screen_view', {
      screen_name: screenName,
      app_name: 'Web App',
      page_title: screenName,
    });
  }

  logEvent({ eventName, eventParams }) {
    // fb.analytics.logEvent(eventName, JSON.parse(eventParams));
    fb.analytics.logEvent(eventName, eventParams);
  }
}

// Instantiate the plugin
const AnalyticsPlugin = new AnalyticsPluginWeb();

registerWebPlugin(AnalyticsPlugin);
